import api from "@/api/v1-jwt/config/api";

const getAuthInfo = async (cognitoId) => {
  try {
    const apiUrl = `${import.meta.env.VITE_PBTECH_API_ENDPOINT}/${
      import.meta.env.VITE_PBTECH_API_VERSION
    }/plaid/auth`;

    const headers = {
      "x-api-key": import.meta.env.VITE_PBTECH_API_KEY,
      "Content-Type": "application/json",
    };

    const responseData = await api.post(
      `/plaid/auth`,
      { cognito_id: cognitoId },
      { headers }
    );
    return responseData;
  } catch (err) {
    console.error("Error fetching access token:", err);
    if (err.response) {
      console.error("Server responded with:", err.response.data);
    }
  }
};

export default getAuthInfo;
